import { render, staticRenderFns } from "./data-list.vue?vue&type=template&id=bbb6e00c&scoped=true"
import script from "./data-list.vue?vue&type=script&lang=js"
export * from "./data-list.vue?vue&type=script&lang=js"
import style0 from "./data-list.vue?vue&type=style&index=0&id=bbb6e00c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb6e00c",
  null
  
)

export default component.exports